<template>
  <DsChecklistSection
    title-id="preventa-defined-property-title"
    title-base="Si ya tienes"
    title-highlight="inmueble definido"
    subtitle="Considera lo siguiente para validar tus anticipos"
    :icon-src="definedPropertyIcon"
    :check-icon-src="checkIcon"
    :items="items"
    :notice="notice"
    notice-placement="footer"
  />
</template>

<script setup lang="ts">
import checkIcon from '../../../../../assets/preventa/Layer_1.svg'
import definedPropertyIcon from '../../../../../assets/preventa/check_circle_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24 1.svg'
import warningIcon from '../../../../../assets/preventa/warning_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24 1.svg'
import DsChecklistSection from '../components/DsChecklistSection.vue'

const items = [
  {
    id: 'account-holder',
    text: 'Los pagos deben salir de la cuenta del titular del financiamiento'
  },
  {
    id: 'seller-payment',
    text: 'Los anticipos deben realizarse a favor del vendedor'
  },
  {
    id: 'third-party-payment',
    text: 'Si otra persona realizó pagos, deberá aparecer en la escritura'
  },
  {
    id: 'legal-entities',
    text: 'No se aceptan anticipos realizados por personas morales'
  },
  {
    id: 'cash-payment',
    emphasis: 'Si el anticipo fue en efectivo:',
    text: 'deberá representar al menos el 20% del enganche'
  }
]

const notice = {
  label: 'Importante:',
  text: 'Todos los recursos deben contar con trazabilidad.',
  iconSrc: warningIcon
}
</script>
